export default __webpack_public_path__ + "static/media/feb2024-2.13b5c3ee.jpg";